import React from 'react';
import BaseMap from '../BaseMap';
import UnitsOverlay from '../UnitsOverlay';

const MediaPlayer = ({ 
  videoFiles, 
  visibleFiles, 
  videoRefs, 
  audioRef,
  unitId, 
  selectedProject, 
  selectedSession,
  currentVideoTime,
  isPlaying,
  projectInfo,
  currentGpsMessage,
  unitName,
  mapRef,
  mapContainerRef
}) => {
  // Get session info from project data if available
  const sessionInfo = projectInfo?.sessions?.find(s => 
    s.objectId === selectedSession
  );
  
  // Use project file info for video files if available
  const projectVideoFiles = sessionInfo?.logFiles?.filter(f => ['mkv', 'avi'].includes(f.suffix)) || [];
  const displayVideoFiles = projectVideoFiles.length > 0 ? projectVideoFiles : videoFiles;
  
  // Check for GPS files from project info
  const hasGpsFiles = sessionInfo?.logFiles?.some(f => f.suffix === 'gps');
  
  // Check for audio files from project info
  const hasAudioFiles = sessionInfo?.logFiles?.some(f => f.suffix === 'wav');

  return (
    <>
      <div className="videos-container" style={{
        display: 'grid',
        gridTemplateColumns: displayVideoFiles.length > 1 ? 'repeat(2, 1fr)' : displayVideoFiles.length === 1 ? 'repeat(2, 1fr)' : '1fr',
        gap: '10px',
        marginBottom: '10px'
      }}>
        {displayVideoFiles.length > 0  && displayVideoFiles.filter(videoFile => visibleFiles.includes(videoFile.filename)).map((videoFile, index) => (
          <div key={videoFile.filename} className="video-container">
            <video
              ref={el => videoRefs.current[index] = el}
              className="video-player"
              style={{ width: '100%', height: 'auto' }}
            >
              <source src={`${process.env.REACT_APP_BASE_URL}/sessions/stream/video/${unitId}/${selectedProject}/${selectedSession}?file=${videoFile.filename}`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div style={{ fontSize: '12px', textAlign: 'center', marginTop: '4px' }}>
              {videoFile.filename}
              {videoFile.syncStartDelay > 0 && (
                <span style={{ color: '#666', fontSize: '11px' }}> (+{(videoFile.syncStartDelay / 1000000).toFixed(3)}s)</span>
              )}
            </div>
          </div>
        )) }

      
        
        {/* Map as last video container */}
        {hasGpsFiles && visibleFiles.some(f => 
          sessionInfo?.logFiles?.find(file => file.filename === f && file.suffix === 'gps')
        ) && (
          <div className="video-container">
            <div className="map-container" ref={mapContainerRef} style={{
              width: '100%',
              minHeight: '300px',
              height: '100%',
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}>
              <BaseMap
                onMapReady={(map) => { 
                  mapRef.current = map;
                  if (currentGpsMessage) {
                    map.setCenter({ lat: currentGpsMessage.latitude, lng: currentGpsMessage.longitude });
                    map.setZoom(14);
                  }
                }}
                onMapChange={() => {}}
                selectedUnit={null}
              />
              <UnitsOverlay
                units={currentGpsMessage ? [{
                  unit_id: unitId,
                  name: unitName,
                  speed: currentGpsMessage.speed,
                  last_pos_latitude: currentGpsMessage.latitude,
                  last_pos_longitude: currentGpsMessage.longitude,
                  bearing: currentGpsMessage.bearing || 0,
                  altitude: currentGpsMessage.seaLevelAltitude
                }] : []}
                map={mapRef.current}
                mapContainer={mapContainerRef.current}
                selectedUnit={null}
                onUnitSelect={() => {}}
                stateData={{}}
                setActiveUnit={() => {}}
                onContextMenu={() => {}}
                onSessionVideos={() => {}}
                useMiniMap={true}
              />
            </div>
          </div>
        )}
      </div>
      
      {/* Audio element - only render if sound-device file exists and is visible */}
      {hasAudioFiles && visibleFiles.some(f => 
        sessionInfo?.logFiles?.find(file => file.filename === f && file.suffix === 'wav')
      ) && (
        <audio 
          key={`audio-${unitId}-${selectedSession}`} 
          ref={audioRef} 
          className="hidden-audio"
          onLoadedData={() => {
            if (audioRef.current && currentVideoTime > 0) {
              audioRef.current.currentTime = currentVideoTime;
              if (isPlaying) {
                audioRef.current.play().catch(e => console.log('Audio play interrupted:', e.name));
              }
            }
          }}
        >
          <source src={`${process.env.REACT_APP_BASE_URL}/sessions/stream/audio/${unitId}/${selectedProject}/${selectedSession}`} />
        </audio>
      )}
    </>
  );
};

export default MediaPlayer;